import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { TrendingUp, Activity, BarChart3, Trophy, MoreHorizontal, X, DollarSign, HelpCircle, BookOpen, Shield } from "lucide-react";

const tabs = [
  { id: "home", label: "Home", icon: TrendingUp, path: "/" },
  { id: "live", label: "Live", icon: Activity, path: "/live" },
  { id: "performance", label: "Stats", icon: BarChart3, path: "/performance" },
  { id: "leaderboard", label: "Rank", icon: Trophy, path: "/leaderboard" },
  { id: "more", label: "More", icon: MoreHorizontal, path: null },
];

const moreLinks = [
  { label: "Pricing", icon: DollarSign, path: "/pricing" },
  { label: "How It Works", icon: BookOpen, path: "/how-it-works" },
  { label: "FAQ", icon: HelpCircle, path: "/faq" },
  { label: "Prop Firm", icon: Shield, path: "/prop-firm" },
];

export default function MobileBottomNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const [showMore, setShowMore] = useState(false);

  const isActive = (path) => {
    if (!path) return false;
    return location.pathname === path;
  };

  const isMoreActive = moreLinks.some((link) => location.pathname === link.path);

  return (
    <>
      {showMore && (
        <div className="fixed inset-0 z-40 md:hidden" onClick={() => setShowMore(false)}>
          <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />
          <div
            className="absolute bottom-[72px] left-4 right-4 bg-[#111111] border border-[#27272A] rounded-2xl p-4 space-y-1"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between mb-3">
              <span className="text-sm font-medium text-[#A1A1AA]">More</span>
              <button onClick={() => setShowMore(false)} className="text-[#A1A1AA]">
                <X className="w-4 h-4" />
              </button>
            </div>
            {moreLinks.map((link) => (
              <button
                key={link.path}
                onClick={() => { navigate(link.path); setShowMore(false); }}
                className={`flex items-center gap-3 w-full px-4 py-3 rounded-xl text-sm font-medium transition-colors ${
                  location.pathname === link.path
                    ? "bg-[#00E676]/10 text-[#00E676]"
                    : "text-[#E5E5E5] hover:bg-[#1C1C1E]"
                }`}
              >
                <link.icon className="w-5 h-5" />
                {link.label}
              </button>
            ))}
          </div>
        </div>
      )}

      <nav className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-[#0A0A0A]/90 backdrop-blur-xl border-t border-[#27272A] safe-bottom">
        <div className="flex items-center justify-around h-[68px] px-2">
          {tabs.map((tab) => {
            const active = tab.path ? isActive(tab.path) : (showMore || isMoreActive);
            return (
              <button
                key={tab.id}
                onClick={() => {
                  if (tab.path) {
                    navigate(tab.path);
                    setShowMore(false);
                  } else {
                    setShowMore(!showMore);
                  }
                }}
                className={`flex flex-col items-center justify-center gap-1 w-16 h-14 rounded-xl transition-colors ${
                  active ? "text-[#00E676]" : "text-[#71717A]"
                }`}
              >
                <tab.icon className={`w-5 h-5 ${active ? "text-[#00E676]" : ""}`} />
                <span className="text-[10px] font-medium">{tab.label}</span>
              </button>
            );
          })}
        </div>
      </nav>
    </>
  );
}
